/**
 * Parses `vendor_initiations.is_material` from API (Annexure 7 overall assessment).
 * `true` = Material, `false` = Non-material, `null` = not set.
 */
export function parseVmsIsMaterialFromApi(value: unknown): boolean | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
    return null;
  }
  if (typeof value === 'string') {
    const s = value.trim().toLowerCase();
    if (s === '' || s === 'null') return null;
    if (s === '1' || s === 'true' || s === 'yes') return true;
    if (s === '0' || s === 'false' || s === 'no') return false;
  }
  return null;
}

/** Notification Regulator step applies only to material vendors (Annexure 7). */
export function showVmsNotificationRegulatorForMaterial(isMaterial: boolean | null): boolean {
  return isMaterial === true;
}
